<template>
  <div class="row ml-2 mb-5" v-if="form.data.value_type">
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Discount Amount</h4>
      <a-input label="Discount amount" v-model="form.data.value" input-classes="form-control" style="margin-bottom: 0px;" placeholder="Enter a amount for your discount" required :disabled="viewOnly" />
      <small>Example: ₱100, ₱300, ₱500</small>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Applies to</h4>
      <base-radio class="mb-2" name="all" value="all" v-model="form.data.target_selection">
        All Products
        <br><small>Discount is applicable to all products of the store</small>
      </base-radio>
      <base-radio class="mb-2 custom-control-label-100" name="entitled" value="entitled" v-model="form.data.target_selection">
        Specific Products
        <br><small>Discount is applicable to the selected products</small>
        <product-search-tab
          v-if="form.data.target_selection === 'entitled'"
          :form="form"
          :products="form.data.entitled_product_ids"
          :viewOnly="viewOnly"
          :sales_channel_stores="form.sales_channel_stores"
        ></product-search-tab>
      </base-radio>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Allocation method</h4>
      <base-radio class="mb-2" name="across" value="across" v-model="form.data.allocation_method">
        Once per order
        <br><small>Discount will be applied to the order's subtotal</small>
      </base-radio>
      <base-radio class="mb-2" name="each" value="each" v-model="form.data.allocation_method">
        Each line item
        <br><small>Discount will be applied to each item of the order</small>
      </base-radio>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">Minimum requirements</h4>
      <base-radio class="mb-2" name="none" value="none" v-model="form.data._prerequisite_type">
        None
      </base-radio>
      <base-radio class="mb-2" name="subtotal" value="subtotal" v-model="form.data._prerequisite_type">
        Minimum purchase amount (₱)
        <a-input v-if="form.data._prerequisite_type === 'subtotal'" v-model="form.data.prerequisite_subtotal_range.greater_than_or_equal_to" input-classes="form-control" style="margin-top: 5px;" placeholder="Subtotal amount" required :disabled="viewOnly" />
      </base-radio>
      <base-radio class="mb-2" name="quantity" value="quantity" v-model="form.data._prerequisite_type">
        Minimum quantity of items
        <a-input v-if="form.data._prerequisite_type === 'quantity'" v-model="form.data.prerequisite_quantity_range.greater_than_or_equal_to" input-classes="form-control" style="margin-top: 5px;" placeholder="No. of items" required :disabled="viewOnly" />
        <br><small class="text-muted">Applies only to selected products</small>
      </base-radio>
    </div>
    <div class="col-md-12 pt-4" v-if="form.data._prerequisite_type !== 'subtotal' && storeTypes['lazada']">
      <h4 class="card-title mb-2">
        Trigger amount
        <tooltip :message="'Only applies to Lazada'"></tooltip>
      </h4>
      <a-input v-model="form.data.prerequisite_subtotal_range.greater_than_or_equal_to" input-classes="form-control col-6" style="margin-top: 5px;" placeholder="Item subtotal amount" required :disabled="viewOnly" />
      <small>Promotion will only apply if order value reaches the set amount</small>
    </div>
    <div class="col-md-12 pt-4">
      <h4 class="card-title mb-2">
        Usage limits
        <tooltip :message="'Only applies to Shopify & BXI Online Store'"></tooltip>
      </h4>
      <base-checkbox class="mb-2" :value="true" v-model="form.data._usage_limit">
        Limit number of times this discount can be used in total
        <a-input v-if="form.data._usage_limit" v-model="form.data.usage_limit" input-classes="form-control" style="margin-top: 5px;" placeholder="Usage limit" required :disabled="viewOnly" />
      </base-checkbox>
      <base-checkbox class="mb-2" :value="true" v-model="form.data.once_per_customer">
        Limit to one use per customer
      </base-checkbox>
    </div>
    <div class="col-md-12 pt-4" v-if="storeTypes['lazada']">
      <h4 class="card-title mb-2">
        Lazada promotion limits
        <tooltip :message="'Only applies to Lazada'"></tooltip>
      </h4>
      <label class="mb-0">Voucher display area</label>
      <a-select :options="display_area_options" style="margin-top: 5px; margin-bottom: 0px; width: 100%" v-model="form.data.display_area"></a-select>
      <small>Area where customers can see the voucher</small>
      <br class="mb-2">
      <label class="mb-0">Total number of vouchers to be issued</label>
      <a-input v-model="form.data.total_issued" input-classes="form-control" style="margin-top: 5px;" placeholder="Total issued vouchers" required :disabled="viewOnly" />
      <br class="my-3">
      <label class="mb-0">Customer voucher limit</label>
      <a-input v-model="form.data.total_limit" input-classes="form-control" style="margin-top: 5px;" placeholder="Usage limit" required :disabled="viewOnly" />
    </div>
    <div class="d-none">{{validationErrors}}</div>
  </div>
  <div v-else></div>
</template>
<script>
  import ProductSearchTab from './ProductSearchTab'
  import Tooltip from './Tooltip'

  export default {
    props: {
      form: Object,
      promotion: Object,
      viewOnly: Boolean,
      storeTypes: Object
    },
    components: {
      ProductSearchTab,
      Tooltip
    },
    name: "fixed-amount-discount",
    data() {
      return {
        display_area_options: [
          {label: 'Regular Channel', value: 'REGULAR_CHANNEL', disabled: false },
          {label: 'Store Followers', value: 'STORE_FOLLOWER', disabled: false },
          {label: 'Offline', value: 'OFFLINE', disabled: false },
          {label: 'Live Streams', value: 'LIVE_STREAM', disabled: false },
          {label: 'Share Vouchers', value: 'SHARE_VOUCHER', disabled: false },
          {label: 'CEM Seller', value: 'CEM_SELLER', disabled: false }
        ]
      }
    },
    methods: {
      validatePromotion: function(){
        let errors = []
        let data = this.form.data
        this.form.data.validationErrors = []

        data.prerequisite_subtotal_range = data.prerequisite_subtotal_range || {}
        data.prerequisite_quantity_range = data.prerequisite_quantity_range || {}
        data.value = data.value ? parseInt(data.value) : 0
        data.total_issued = data.total_issued ? parseInt(data.total_issued) : 0
        data.total_limit = data.total_limit ? parseInt(data.total_limit) : 0
        if(data.value <= 0)
          errors.push('Discount amount must be greater than 0')
        if(this.storeTypes['lazada'] && data.total_issued <= 0)
          errors.push('Total number of vouchers to be issued must be greater than 0')
        if(this.storeTypes['lazada'] && data.total_limit <= 0)
          errors.push('Customer voucher limit must be greater than 0')
        if(data.total_limit > data.total_issued)
          errors.push('Total number of vouchers to be issued must be greater than customer voucher limit')
        if(data.target_selection === 'entitled' && data.entitled_product_ids.length === 0)
          errors.push('Specific products must be added')
        if(data._prerequisite_type === 'subtotal'){
          data.prerequisite_subtotal_range.greater_than_or_equal_to = data.prerequisite_subtotal_range.greater_than_or_equal_to ? parseFloat(data.prerequisite_subtotal_range.greater_than_or_equal_to) : 0
          if(data.prerequisite_subtotal_range.greater_than_or_equal_to <= 0)
            errors.push('Minimum purchase amount must be greater than 0')
        }
        if(data._prerequisite_type === 'quantity'){
          data.prerequisite_quantity_range.greater_than_or_equal_to = data.prerequisite_quantity_range.greater_than_or_equal_to ? parseInt(data.prerequisite_quantity_range.greater_than_or_equal_to) : 0
          if(data.prerequisite_quantity_range.greater_than_or_equal_to <= 0)
            errors.push('Minimum item quantity must be greater than 0')
        }
        if(data._usage_limit){
          data.usage_limit = data.usage_limit ? parseInt(data.usage_limit) : 0
          if(data.usage_limit <= 0)
            errors.push('Usage limit must be greater than 0')
        }

        this.form.data.validationErrors = errors
        return errors
      }
    },
    computed: {
      validationErrors: function () {
        return this.validatePromotion()
      }
    },
    mounted: function(){
      let starts_at = new Date()
      let ends_at = new Date()
      ends_at = new Date(ends_at.setMonth(ends_at.getMonth() + 1))
      this.form.data = {
        ...{
          title: this.form.code,
          value_type: 'fixed_amount',
          value: null,
          target_type: 'line_item',
          target_selection: 'all',
          allocation_method: 'across',
          customer_selection: 'all',
          original_entitled_product_ids: [],
          entitled_product_ids: [],
          _prerequisite_type: 'none',
          prerequisite_subtotal_range: {
            greater_than_or_equal_to: null
          },
          prerequisite_quantity_range: {
            greater_than_or_equal_to: null
          },
          _usage_limit: false,
          usage_limit: null,
          once_per_customer: false,
          starts_at: starts_at.toDateString(),
          ends_at: ends_at.toDateString(),
          collect_start: starts_at.toDateString(),
          collect_end: ends_at.toDateString(),
          _ends_at: true,
          total_issued: 1,
          total_limit: 1,
          display_area: 'REGULAR_CHANNEL',
          validationErrors: []
        },
        ...this.form.data
      }
      this.form.data.original_entitled_product_ids = JSON.parse(JSON.stringify(this.form.data.entitled_product_ids))
    }
  }
</script>
